<template>
<ItpPage
  card
  no-primary-button
  :closeButtonText="'Close'|gettext"
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Invoice"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :color="$config.invoice.color"
    slot="header"
    v-if="item"
    @close="evh_2248226175642056_close($event, {})"
  >
    <UcInvoiceHeader
      :invoice="item"
      :formContext="formContext"
      :class="b_8564662037462133_class"
      @created="evh_8564662037462133_created($event, {})"
      @deleted="evh_8564662037462133_deleted($event, {})"
      @reload="evh_8564662037462133_reload($event, {})"
    >
    </UcInvoiceHeader>
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpPanel
      collapsible
      :caption="'Invoice data'|pgettext('Invoice')"
      carousel
      class="mb-4"
      v-if="!isNew"
    >
      <UcInvoiceData
        :invoice="item"
        :reload="lastLoaded"
        @reload="evh_5534025912102772_reload($event, {})"
      >
      </UcInvoiceData>
    </ItpPanel>
    <DIV
      class="overflow-hidden w-100"
      v-if="currency && item"
    >
      <UcInvoiceLines
        :invoice="item"
        :currency="currency"
        :defaultTaxCode="item.meta.default_tax_code"
        :defaultDiscount="item.meta.default_discount"
        :reload="lastLoaded"
        :formContext="formContext"
        class="h-100 w-100"
        @reload="evh_1468474219929533_reload($event, {})"
      >
      </UcInvoiceLines>
    </DIV>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    :color="$config.invoice.color"
    slot="footer"
    v-if="item"
  >
    <UcInvoiceFooter
      :invoice="item"
      :currency="currency"
      :exchangedCurrency="exchangedCurrency"
      v-if="currency"
      @reload="evh_1548630417156826_reload($event, {})"
    >
    </UcInvoiceFooter>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "invoice",
    path: "/invoices/:id",
    component: "Invoice",
    params: [{
      name: "id",
      prop: "oid",
    }
      ,
    ]

  }
)

addRoute(
  {
    name: "incomingInvoiceCreate",
    path: "/invoices-in/create",
    component: "Invoice",
    componentProps: [{
      name: "newInvoiceKind",
      value: "incoming",
    }
      ,
    ]

  }
)

addRoute(
  {
    name: "outgoingInvoiceCreate",
    path: "/invoices-out/create",
    component: "Invoice",
    componentProps: [{
      name: "newInvoiceKind",
      value: "outgoing",
    }
      ,
    ]

  }
)

@Component()
export default class Invoice extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: String,
  })
  registerEntry!: string;

  @Watch('registerEntry')
  onRegister_entry(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("registerEntry")
  }

  @Prop({
    type: String,
    default: function() {
      return this.$fn.randomElementId()
    },
  })
  formId!: string;

  @Watch('formId')
  onForm_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formId")
  }

  @Prop({
    type: String,
  })
  newInvoiceKind!: string;

  @Watch('newInvoiceKind')
  onNew_invoice_kind(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("newInvoiceKind")
  }

  @Prop({
    type: String,
    default: "full-screen",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  blankItem!: any;

  async $$load_blankItem() {
    return (this.newInvoiceKind == null && this.register_entry == null) ?
      null :
      this.$fn.fetch('get_invoice_template', {
        parameters: {
          invoice_kind: this.newInvoiceKind,
          register_entry: this.registerEntry
        },
        asResource: true
      })
  }

  item!: any;

  async $$load_item() {
    return this.blankItem ||
      this.$fn.fetch('read_invoice', { parameters: { id: this.oid } })
        .then(d => {

          if (d.billing_period == null) {
            d.billing_period = {
              start: null,
              end: null
            };
          }

          return new this.$fn.Resource(d);
        })
  }

  currencies!: any;

  async $$load_currencies() {
    return this.$app.repo.get('list_currency', { map: true, key: 'code' })
  }

  formContext!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_8564662037462133_class!: any;

  async $$load_b_8564662037462133_class() {
    return {
      "bg-transparent": this.card,
      "shadow-sm": this.card,
    }
  }

  dataMembers = ['blankItem', 'item', 'currencies', 'formContext', 'ux', 'b_7315092382398562_modalBindings', 'b_8564662037462133_class'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        blankItem: null,
        item: null,
        currencies: null,
        formContext: {
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          noPrimaryButton: true,
          closeButtonText: this.$fn.gettext("Close"),
          size: "full-screen",
        }
        ,
        b_8564662037462133_class: null,
      },
    }
  }

  get isNew() {
    if (this.loaded) {

      return !this.item || !this.item.id
    }
    return null;
  }

  get invoiceTypeName() {
    if (this.loaded) {

      return this.item.invoice_type === "correction" ? this.$fn.pgettext("InvoiceType", "Correction") :
        (this.item.invoice_type === "storno" ? this.$fn.pgettext("InvoiceType", "Storno") :
          (this.item.invoice_type === "proforma" ? this.$fn.pgettext("InvoiceType", "Pro Forma") : "?"))
    }
    return null;
  }

  get currency() {
    if (this.loaded) {

      return this.currencies[this.item.currency]
    }
    return null;
  }

  get exchangedCurrency() {
    if (this.loaded) {

      return this.currencies[this.item.exchanged_currency]
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.item.id ? this.item.invoice_number : this.$fn.gettext('Create Invoice'),
        icon: this.$config.invoice.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3170_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3170, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_navigate_3174_getActionArgs($event: actions.ActionEvent): Promise<actions.NavigateActionArgs> {
    // parameterResolver name=act_8564662037462133_navigate_3174, alias=undefined
    return {
      location: {
        name: "app.invoice",
        params: {
          id: $event.data.id,
        }
        ,
      }
      ,
    }
  }

  async evh_8564662037462133_created(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_created.executeFromDOM(this, event, scope);
  }

  async evh_8564662037462133_deleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
  }

  async evh_8564662037462133_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
  }

  async evh_5534025912102772_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_reload.executeFromDOM(this, event, scope);
  }

  async evh_1468474219929533_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1468474219929533_reload.executeFromDOM(this, event, scope);
  }

  async evh_1548630417156826_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3170: actions.CloseModalAction;
    evh_7315092382398562_close_3169: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_3172: actions.CloseModalAction;
    evh_2248226175642056_close_3171: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_8564662037462133_navigate_3174: actions.NavigateAction;
    evh_8564662037462133_created_3173: actions.EventHandlerImpl;
    evh_8564662037462133_created: actions.EventHandlerGroup;
    act_8564662037462133_closeComponent_3176: actions.CloseComponentAction;
    evh_8564662037462133_deleted_3175: actions.EventHandlerImpl;
    evh_8564662037462133_deleted: actions.EventHandlerGroup;
    act_8564662037462133_reloadComponentData_3178: actions.ReloadComponentDataAction;
    evh_8564662037462133_reload_3177: actions.EventHandlerImpl;
    evh_8564662037462133_reload: actions.EventHandlerGroup;
    act_5534025912102772_reloadComponentData_3180: actions.ReloadComponentDataAction;
    evh_5534025912102772_reload_3179: actions.EventHandlerImpl;
    evh_5534025912102772_reload: actions.EventHandlerGroup;
    act_1468474219929533_reloadComponentData_3182: actions.ReloadComponentDataAction;
    evh_1468474219929533_reload_3181: actions.EventHandlerImpl;
    evh_1468474219929533_reload: actions.EventHandlerGroup;
    act_1548630417156826_reloadComponentData_3184: actions.ReloadComponentDataAction;
    evh_1548630417156826_reload_3183: actions.EventHandlerImpl;
    evh_1548630417156826_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3170 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3170_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3169 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3170,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3169],
      }
    );
    const act_2248226175642056_closeModal_3172 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3171 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_3172,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3171],
      }
    );
    const act_8564662037462133_navigate_3174 = new actions.NavigateAction(
      {
        actionArgs: this.act_8564662037462133_navigate_3174_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_created_3173 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_navigate_3174,
        event: "created",
        displayName: "navigate",
      }
    );
    const evh_8564662037462133_created = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_created_3173],
      }
    );
    const act_8564662037462133_closeComponent_3176 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_deleted_3175 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_closeComponent_3176,
        event: "deleted",
        displayName: "closeComponent",
      }
    );
    const evh_8564662037462133_deleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_deleted_3175],
      }
    );
    const act_8564662037462133_reloadComponentData_3178 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_reload_3177 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadComponentData_3178,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_8564662037462133_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_reload_3177],
      }
    );
    const act_5534025912102772_reloadComponentData_3180 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_5534025912102772_reload_3179 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_reloadComponentData_3180,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_5534025912102772_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_reload_3179],
      }
    );
    const act_1468474219929533_reloadComponentData_3182 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_1468474219929533_reload_3181 = new actions.EventHandlerImpl(
      {
        action: act_1468474219929533_reloadComponentData_3182,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_1468474219929533_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_1468474219929533_reload_3181],
      }
    );
    const act_1548630417156826_reloadComponentData_3184 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_1548630417156826_reload_3183 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_reloadComponentData_3184,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_1548630417156826_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_reload_3183],
      }
    );
    return {
      act_7315092382398562_closeModal_3170,
      evh_7315092382398562_close_3169,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_3172,
      evh_2248226175642056_close_3171,
      evh_2248226175642056_close,
      act_8564662037462133_navigate_3174,
      evh_8564662037462133_created_3173,
      evh_8564662037462133_created,
      act_8564662037462133_closeComponent_3176,
      evh_8564662037462133_deleted_3175,
      evh_8564662037462133_deleted,
      act_8564662037462133_reloadComponentData_3178,
      evh_8564662037462133_reload_3177,
      evh_8564662037462133_reload,
      act_5534025912102772_reloadComponentData_3180,
      evh_5534025912102772_reload_3179,
      evh_5534025912102772_reload,
      act_1468474219929533_reloadComponentData_3182,
      evh_1468474219929533_reload_3181,
      evh_1468474219929533_reload,
      act_1548630417156826_reloadComponentData_3184,
      evh_1548630417156826_reload_3183,
      evh_1548630417156826_reload,
    }
  }
}

Vue.component("Invoice", Invoice);

</script>